export const ORDER_TYPE = {
    //todo replace order types mapping
}

export const PROPOSAL = 'PROPOSAL'
export const ORDER = 'ORDER'
export const SERVICE_CALL = 'SERVICE_CALL'